// --------------------------
// IMPORTS
// --------------------------
import APICaller from "./APICaller";
import moment from "moment";
import { store } from "../store";
import { searchInfo } from "../store/slices/authSlice";

const processResponse = (response, totalCount, searchIn, pagination) => {    
  const temp =
    response &&
    response.map((records, index) => ({
      key: records._id,
      id: index + 1,
      ...(searchIn === "permissions" && {
        name: records?.name,
        createdAt: records?.createdAt
          ? moment.utc(records?.createdAt).local().format("DD-MM-YY hh:mm A")
          : "-",
      }),
      ...(searchIn === "roles" && {
        name: records?.name,
        permissions: records?.permissions,
        createdAt: records?.createdAt
          ? moment.utc(records?.createdAt).local().format("DD-MM-YY hh:mm A")
          : "-",
      }),
      ...(searchIn === "notifications" && {
        id: records?._id,
        title: records?.title,
        natureOfExpense: records?.expenseRequestID?.natureOfExpense,
        excerpt: records?.excerpt,
        assignedBy: records?.assignedBy,
        assignedByProfilePicUrl: records?.assignedByProfilePicUrl,
        assignedTo: records?.assignedTo,
        assignedToProfilePicUrl: records?.assignedToProfilePicUrl,
        message: records?.message,
        type: records?.type,
        isRead: records?.isRead === "0" ? "Un-read" : "Read",
        status: records?.status,
        createdAt: records?.createdAt
          ? moment.utc(records?.createdAt).local().format("DD-MM-YY hh:mm:ss A")
          : "-",
      }),
      ...(searchIn === "users" && {
        empID: records?.empID,
        name: records?.name,
        email: records?.email,
        role: records?.roleID.name,
        department: records?.departmentID,
        status: records?.status,
        canDelegateAccess: records?.canDelegateAccess,
        createdAt: records?.createdAt
          ? moment.utc(records?.createdAt).local().format("DD-MM-YY hh:mm A")
          : "-",
        updatedAt: records?.updatedAt
          ? moment.utc(records?.updatedAt).local().format("DD-MM-YY hh:mm A")
          : "-",
      }),
      ...(searchIn === "currency" && {
        code: records?.code,
        symbol: records?.symbol,
        symbol_native: records?.symbol_native,
        currencyRateHistory: records?.currencyRateHistory,
        flagUrl: records?.flagUrl,
        createdAt: records?.createdAt
          ? moment.utc(records?.createdAt).local().format("DD-MM-YY hh:mm A")
          : "-",
        updatedAt: records?.updatedAt
          ? moment.utc(records?.updatedAt).local().format("DD-MM-YY hh:mm A")
          : "-",
      }),
      ...(searchIn === "departments" && {
        name: records?.name,
        code: records?.code,
        createdAt: records?.createdAt
          ? moment.utc(records?.createdAt).local().format("DD-MM-YY hh:mm A")
          : "-",
        updatedAt: records?.updatedAt
          ? moment.utc(records?.updatedAt).local().format("DD-MM-YY hh:mm A")
          : "-",
      }),
      ...(searchIn === "project-code" && {
        departmentID: `${records?.departmentID?.name} - ${records?.departmentID?.code}`,
        departmentName: records?.departmentID?.name,
        code: records?.code,
        clientName: records?.clientName,
        companyName: records?.companyName,
        approvers: records?.approvers,
        status: records?.status,
        createdAt: records?.createdAt
          ? moment.utc(records?.createdAt).local().format("DD-MM-YY hh:mm A")
          : "-",
        updatedAt: records?.updatedAt
          ? moment.utc(records?.updatedAt).local().format("DD-MM-YY hh:mm A")
          : "-",
      }),
      ...(searchIn === "expense-code" && {
        name: records?.name,
        costCode: records?.costCode,
        createdAt: records?.createdAt
          ? moment.utc(records?.createdAt).local().format("DD-MM-YY hh:mm A")
          : "-",
        updatedAt: records?.updatedAt
          ? moment.utc(records?.updatedAt).local().format("DD-MM-YY hh:mm A")
          : "-",
      }),
      ...(searchIn === "list-of-expense" && {
        key: records?._id,
        empName: records?.empName,
        empID: records?.empID,
        businessPurpose: records?.businessPurpose,
        natureOfExpense: records?.natureOfExpense || "-",
        projectCodeID: records?.projectCodeID
          ? records?.projectCodeID
          : "N/A",
        departmentID:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.departmentID || null
            : "-",
        expenseCodeID:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.expenseCodeID || null
            : "-",
        currencyID:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.currencyID || null
            : "-",
        cost:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.cost || null
            : "-",
        totalReimbursement: records?.totalReimbursement,
        approvers: records?.approvers,
        adminApprover:
          records.status ===
            process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
          records?.adminApprover?.[0]?.status ===
            process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
          records?.adminApprover?.[0]?.reason
            ? process.env.REACT_APP_SENTBACK_STATUS
            : records?.adminApprover?.[0]?.status ===
              process.env.REACT_APP_APPROVED_STATUS.toUpperCase()
            ? process.env.REACT_APP_APPROVED_STATUS
            : records?.adminApprover?.[0]?.status ===
                process.env.REACT_APP_CANCELED_STATUS.toUpperCase() &&
              records?.adminApprover?.[0]?.reason
            ? process.env.REACT_APP_CANCELED_STATUS
            : records.status ===
              process.env.REACT_APP_DRAFT_STATUS.toUpperCase()
            ? "-"
            : process.env.REACT_APP_PENDING_STATUS,
        expensePeriod:
          records?.expensePeriodFromDate && records?.expensePeriodToDate
            ? moment(records.expensePeriodFromDate).format("Do MMM, YYYY") +
              " - " +
              moment(records.expensePeriodToDate).format("Do MMM, YYYY")
            : "-",
        month: records?.expensePeriodFromDate
          ? moment(records.expensePeriodFromDate).format("MMM")
          : "-",
        expensePeriodFromDate: records?.expensePeriodFromDate
          ? moment(records.expensePeriodFromDate).format("DD-MM-YY")
          : "-",
        expensePeriodToDate: records?.expensePeriodToDate
          ? moment(records.expensePeriodToDate).format("DD-MM-YY")
          : "-",
        onBehalfApprovers: records?.onBehalfApprovers || null,
        children:
          records?.expensesDetails && records?.expensesDetails.length > 1
            ? records.expensesDetails.map((item, index) => ({
                key: item._id || index,
                date: item?.date ? moment(item.date).format("DD-MM-YYYY") : "-",
                description: item?.description || "-",
                departmentID: item?.departmentID || "-",
                expenseCodeID: item?.expenseCodeID || "-",
                currencyID: item?.currencyID || "-",
                cost: item?.cost || "-",
              }))
            : null,
        paymentPaidOn: records?.paymentPaidOn || null,
        modeOfPayment: records?.modeOfPayment || null,
        status: records?.history[records?.history.length - 1]?.status,
        profilePicUrl: records?.profilePicUrl,
      }),
      ...(searchIn === "pending-requests" && {
        key: records?._id,
        empName: records?.empName,
        empID: records?.empID,
        natureOfExpense: records?.natureOfExpense || "-",
        businessPurpose: records?.businessPurpose,
        projectCodeID: records?.projectCodeID ? records.projectCodeID : "N/A",
        expensePeriod:
          records?.expensePeriodFromDate && records?.expensePeriodToDate
            ? moment(records.expensePeriodFromDate).format("Do MMM, YYYY") +
              " - " +
              moment(records.expensePeriodToDate).format("Do MMM, YYYY")
            : "-",
        month: records?.expensePeriodFromDate
          ? moment(records.expensePeriodFromDate).format("MMM")
          : "-",
        departmentID:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.departmentID || null
            : "-",
        expenseCodeID:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.expenseCodeID || null
            : "-",
        currencyID:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.currencyID || null
            : "-",
        cost:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.cost || null
            : "-",
        adminApprover:
          records.status ===
            process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
          records?.adminApprover?.[0]?.status ===
            process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
          records?.adminApprover?.[0]?.reason
            ? process.env.REACT_APP_SENTBACK_STATUS
            : records?.adminApprover?.[0]?.status ===
              process.env.REACT_APP_APPROVED_STATUS.toUpperCase()
            ? process.env.REACT_APP_APPROVED_STATUS
            : records?.adminApprover?.[0]?.status ===
                process.env.REACT_APP_CANCELED_STATUS.toUpperCase() &&
              records?.adminApprover?.[0]?.reason
            ? process.env.REACT_APP_CANCELED_STATUS
            : records.status ===
              process.env.REACT_APP_DRAFT_STATUS.toUpperCase()
            ? "-"
            : process.env.REACT_APP_PENDING_STATUS,
        approvers: records?.approvers,
        totalReimbursement: records?.totalReimbursement,
        status: records?.history[records?.history.length - 1]?.status,
        paymentPaidOn: records?.paymentPaidOn || null,
        modeOfPayment: records?.modeOfPayment || null,
        expensePeriodFromDate: records?.expensePeriodFromDate
          ? moment(records.expensePeriodFromDate).format("DD-MM-YY")
          : "-",
        profilePicUrl: records?.profilePicUrl,
        children:
          records?.expensesDetails && records?.expensesDetails.length > 1
            ? records.expensesDetails.map((item, index) => ({
                key: item._id || index,
                date: item?.date ? moment(item.date).format("DD-MM-YYYY") : "-",
                description: item?.description || "-",
                departmentID: item?.departmentID || "-",
                expenseCodeID: item?.expenseCodeID || "-",
                currencyID: item?.currencyID || "-",
                cost: item?.cost || "-",
              }))
            : null,
      }),
      ...(searchIn === "vendors" && {
        name: records?.name,
        status: records?.status === "SOFTDELETE" ? "INACTIVE" : records.status,
        createdAt: records?.createdAt
          ? moment.utc(records?.createdAt).local().format("DD-MM-YY hh:mm A")
          : "-",
        updatedAt: records?.updatedAt
          ? moment.utc(records?.updatedAt).local().format("DD-MM-YY hh:mm A")
          : "-",
      }),
    }));
  
  store.dispatch(
    searchInfo({
      totalCount,
      list: {
        name: searchIn,
        [searchIn + "_info"]: temp,
        [searchIn + "_total"]: totalCount,
      },
      pagination: {
        ...pagination,
        current: pagination.current || pagination.page,
        page: pagination.current || pagination.page,
        pageSize: pagination.pageSize,
        total: totalCount,
      },
    })
  );
};

const HandleSearch = async (
  role,
  token,
  lIUId,
  storeAccessTokenExpiresOn,
  searchIn,
  callActionFrom,
  allStates,
  totalCount
) => {
  const {
    pagination,
    tab,
    fetchWithoutPagination,
    status,
    isRecent,
    filterValues,
    searchKeyword,
  } = allStates;

  const { current, page, pageSize, total } = pagination;
  const pge = current || page;
  const action = "findAll";

  try {
    const endpoint = `/${searchIn}/${action}`;
    const method = "POST";
    const payload = {
      page: pge,
      pageSize,
      role,
      totalCount,
      lIUId,
      searchIn,
      tab,
      ...(fetchWithoutPagination ? { fetchWithoutPagination } : {}),
      status: status || "",
      ...(isRecent ? { isRecent } : {}),
      //isRecent: isRecent || false,
      filterValues: filterValues || "",
      searchKeyword,
    };

    const allRecs = await APICaller(
      role,
      token,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    );
    
    if (allRecs?.response) {

      processResponse(
        allRecs.response,
        allRecs.totalCount,
        searchIn,
        pagination
      );
    }
  } catch (error) {
    //message.error("Error fetching data:"+ error);
  }
};

export default HandleSearch;
